import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { helpdeskContactUrl } from '@shared/constants/helpdesk-urls';

@Component({
  selector: 'itc-copyright',
  templateUrl: 'copyright.component.html',
  styleUrl: 'copyright.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class CopyrightComponent {
  readonly isDark = input(false);

  readonly helpAndSupportLink = helpdeskContactUrl;

  get year(): number {
    return new Date().getFullYear();
  }
}
